import { z } from 'zod';

export const OpportunitySubmissionCandidateExperiencesSchema = z.object({
  submissionDescription: z.string(),
});

export type SubmissionDetails = z.infer<
  typeof OpportunitySubmissionCandidateExperiencesSchema
>;
